/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  DailyActivityMonitoringLogStatusDto,
  GetAllDailyActivityMonitoringLogStatusesParams,
  IReadOnlyListOfDailyActivityMonitoringLogStatusDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all dailyactivitymonitoringlogstatus enumeration values, with an optional filter.
 */
export const getAllDailyActivityMonitoringLogStatuses = (
    params?: GetAllDailyActivityMonitoringLogStatusesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfDailyActivityMonitoringLogStatusDto>>,) => {
      return customInstance<IReadOnlyListOfDailyActivityMonitoringLogStatusDto>(
      {url: `/deployment/daily-activity-monitoring-log-statuses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the DailyActivityMonitoringLogStatus identified by the route id.
 */
export const getDailyActivityMonitoringLogStatusById = (
    id: number,
 options?: SecondParameter<typeof customInstance<DailyActivityMonitoringLogStatusDto>>,) => {
      return customInstance<DailyActivityMonitoringLogStatusDto>(
      {url: `/deployment/daily-activity-monitoring-log-statuses/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllDailyActivityMonitoringLogStatusesResult = NonNullable<Awaited<ReturnType<typeof getAllDailyActivityMonitoringLogStatuses>>>
export type GetDailyActivityMonitoringLogStatusByIdResult = NonNullable<Awaited<ReturnType<typeof getDailyActivityMonitoringLogStatusById>>>
